import React from 'react'
import { useNavigate } from 'react-router-dom'
import WebCopywriter1 from "../assets/images/svg/WebCopywriter1.svg"
import WebCopywriter2 from "../assets/images/svg/WebCopywriter2.svg"
import WebCopywriter3 from "../assets/images/svg/WebCopywriter3.svg"
import WebCopywriter4 from "../assets/images/svg/WebCopywriter4.svg"
import WebCopywriter5 from "../assets/images/svg/WebCopywriter5.svg"
import WebCopywriter6 from "../assets/images/svg/WebCopywriter6.svg"
import WebCopywriter7 from "../assets/images/svg/WebCopywriter7.svg"
import WebCopywriter8 from "../assets/images/svg/WebCopywriter8.svg"
import MoreServicesBtn from "../assets/images/svg/more-services-btn.svg"
import LatestBlog from '../component/LatestBlog'
import FixHeader from '../component/FixHeader'
import ClientsSaySlider from '../component/ClientsSaySlider'
import Loader from "../component/Loader"
import Footer from "../component/Footer"



const Services1 = () => {
    const navigate = useNavigate()
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="about-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Services</h1>
                    <ul className="breadcrumb-list about-breadcrumb aos-init aos-animate" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/Services1")}>Services</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/Services1")}>Services 1</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two">
                <div className="container position-relative">
                    <h2 className="section-heading-text services-page-one-text-main" data-aos="fade-down"><span> Content
                        Write</span> Services</h2>
                    <p className="section-sub-text pharetra" data-aos="fade-down">Pharetra elementum risus quam et
                        adipiscing ac tempor. Donec gravida sagittis elit ullamcorper sed phasellus tincidunt velit
                        ultricies commodo.</p>
                    <div className="row section-five-row pb-0">
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter1} alt="WebCopywriter1" />
                                <h3 onClick={() => navigate("/ServicesDetails1")}>Web Copywriter</h3>
                                <p>Scelerisque lobortis cras et varius amet odio justo lectus ac. Faucibus eget nam tincidunt convallis.</p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => navigate("/ServicesDetails1")} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="more-services-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-down">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter2} alt="WebCopywriter1" />
                                <h3 onClick={() => navigate("/ServicesDetails2")}>Brochure Copywriter</h3>
                                <p>Tincidunt enim nunc augue facilisis vulputate tortor pharetra orci. Commodo tortor.</p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => navigate("/ServicesDetails2")} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="more-services-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter3} alt="WebCopywriter3" />
                                <h3 onClick={() => navigate("/ServicesDetails3")}>Digital Copywriting</h3>
                                <p>Enim habitasse pretium interdum fermentum et sagittis et. Ut nibh nulla sed a ante augue.</p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => navigate("/ServicesDetails3")} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="more-services-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-down">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter4} alt="WebCopywriter4" />
                                <h3 onClick={() => navigate("/ServicesDetails1")}>Email Copywriting</h3>
                                <p>In sed eu sed nunc posuere aliquam at lectus amet. Lacus sapien lacus duis orci.</p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => navigate("/ServicesDetails1")} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="more-services-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter5} alt="WebCopywriter5" />
                                <h3 onClick={() => navigate("/ServicesDetails2")}>Blog Content Writer</h3>
                                <p>Scelerisque lobortis cras et varius amet odio justo lectus ac. Faucibus eget nam tincidunt convallis.</p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => navigate("/ServicesDetails2")} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="more-services-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-down">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter6} alt="WebCopywriter6" />
                                <h3 onClick={() => navigate("/ServicesDetails3")}>Press Release Writer</h3>
                                <p>Tincidunt enim nunc augue facilisis vulputate tortor pharetra orci. Commodo tortor.</p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => navigate("/ServicesDetails3")} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="more-services-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter7} alt="WebCopywriter7" />
                                <h3 onClick={() => navigate("/ServicesDetails1")}>Video Script Writer</h3>
                                <p>Enim habitasse pretium interdum fermentum et sagittis et. Ut nibh nulla sed a ante augue.</p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => navigate("/ServicesDetails1")} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="more-services-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-down">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter8} alt="WebCopywriter8" />
                                <h3 onClick={() => navigate("/ServicesDetails2")}>Content Marketing</h3>
                                <p>In sed eu sed nunc posuere aliquam at lectus amet. Lacus sapien lacus duis orci.</p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => navigate("/ServicesDetails2")} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="more-services-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== About Section Six ===================================== --> */}
            <ClientsSaySlider />
            {/* <!-- ====================================== About Section Seven ===================================== --> */}
            <LatestBlog />
            <Footer />
        </>
    )
}
export default Services1                                       